import * as React from 'react';
import * as moment_timezone from 'moment-timezone';
import { Event } from '../calendar/calendar.event.types';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import RaisedButton from 'material-ui/RaisedButton';
import './calendar.css';
import { WEEK_VIEW, CALENDAR_EVENT_SELECTED, CREATE_CALENDAR_EVENT } from '../calendar/calendar.constants';
import { createMinMaxTime } from '../calendar/calendar.util';
import { cannotWrite } from '../util/permission.util';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { PROGRAM } from '../account/Constants';
import { mmsStore } from '../app/app.config';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';

const BigCalendar = require('react-big-calendar');

type Props = {
  readonly events: Array<Event>
  readonly openProgramsModalHandler?: Function
  readonly authState: AuthState
  readonly adminState: AdminState
};

type States = {
  readonly event: Event
  readonly events: Array<Event>
  readonly start: Date
  readonly levels: Array<string>
  readonly isCreateEventModalOpen: boolean
  readonly isEditEventModalOpen: boolean
};

class Calendar extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      event: {id: 0, title: ''},
      events: props.events,
      levels: [],
      start: new Date(),
      isCreateEventModalOpen: false,
      isEditEventModalOpen: false
    };

    BigCalendar.momentLocalizer(moment_timezone);

    this.customToolbar = this.customToolbar.bind(this);
    this.handleCreateEventStepperOpen = this.handleCreateEventStepperOpen.bind(this);
    this.handleSelectEvent = this.handleSelectEvent.bind(this);
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps) {
      this.setState({events: nextProps.events});
    }
  }

  componentWillUnmount() {
    this.setState({
      isCreateEventModalOpen: false,
      isEditEventModalOpen: false
    });
  }

  render() {
    const { start, events } = this.state;

    return (
      <div>
        <BigCalendar
          date={start}
          selectable={false}
          events={events}
          defaultView={WEEK_VIEW}
          views={[WEEK_VIEW]}
          min={createMinMaxTime(7, start)}
          max={createMinMaxTime(23, start)}
          components={{
            toolbar: this.customToolbar
          }}
          messages={{allDay: ''}}
          onSelectEvent={this.handleSelectEvent}
          eventPropGetter={this.pickColorForEvent}
        />
      </div>
    );
  }

  private pickColorForEvent = (event: Event, start: Date, end: Date, isSelected: boolean) => {
    return {
      style: {
        backgroundColor: event.backgroundColor
      }
    };
  }

  private handleSelectEvent = (event: Event): void => {
    mmsStore.dispatch(
      {
        type: CALENDAR_EVENT_SELECTED,
        payload: {
          body: {
            entity: {
              id: event.id,
              title: event.title,
              colorValue: event.backgroundColor
            }
          }
        }
      }
    );

    mmsStore.dispatch(push(paths.programDetail));
  }

  private customToolbar = (): JSX.Element => {
    return(
      <div className="col-12 text-right mb-3" style={{padding: 0}}>
        <RaisedButton 
          label={cannotWrite(PROGRAM, this.props.authState, this.props.adminState) ? 'Not Enough Permission' : 'Create'}
          primary={true}
          onClick={this.handleCreateClick}
          disabled={cannotWrite(PROGRAM, this.props.authState, this.props.adminState)}
        />
      </div>
    );
  }

  private handleCreateClick = (): void => {
    mmsStore.dispatch(
      {
        type: CREATE_CALENDAR_EVENT,
        payload: {
          body: {
            entity: {
              id: undefined,
              title: undefined
            }
          }
        }
      }
    );

    mmsStore.dispatch(push(paths.programDetail));
  }

  private handleCreateEventStepperOpen = (): void => {
    if (this.props.openProgramsModalHandler) {
      this.props.openProgramsModalHandler();
    }
    
    this.setState(
      {
        isEditEventModalOpen: false,
        isCreateEventModalOpen: false
      },
      () => this.setState({isCreateEventModalOpen: true})
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/programs/CalendarComponent.tsx